module.exports = __webpack_public_path__ + "img/059f5a7.jpg";